// src/Pages/Products/Products.js
import React from "react";
import { Link } from "react-router-dom";
import { products } from "./ProductData";
import { useCart } from "../../cart/CartContext";
import { toast } from "react-toastify";
import SEO from "../../Components/SEO";
import "./Products.css";
import { getPriceDisplay } from "./Prices";

// Badge component
function Badge({ children }) {
  return (
    <span
      className="badge"
      style={{
        display: "inline-block",
        border: "1px solid rgba(0,0,0,0.08)",
        borderRadius: "999px",
        padding: "4px 10px",
        fontSize: "0.85rem",
        marginRight: 8,
        marginBottom: 8,
      }}
    >
      {children}
    </span>
  );
}

// Single product card
function ProductCard({ p }) {
  const { addItem } = useCart();

  const handleAddToCart = () => {
    addItem({
      id: p.id,
      name: p.name,
      price: 100, // temporary value
      currency: "USD",
      image: p.heroImage,
      quantity: 1,
    });

    toast.success(`${p.name} added to cart 🛒`, { autoClose: 2000 });
  };

  return (
    <div
      className="product-card"
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        background: "#fff",
        border: "1px solid rgba(0,0,0,0.06)",
        borderRadius: 20,
        padding: 20,
        gap: 24,
        boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
        transition: "transform 0.25s ease, box-shadow 0.25s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-4px)";
        e.currentTarget.style.boxShadow = "0 6px 12px rgba(0,0,0,0.08)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.04)";
      }}
    >
      {/* Image */}
      <div
        className="product-card-imageWrap"
        style={{
          flex: "0 0 38%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(180deg, #fafafa 0%, #f5f5f5 100%)",
          borderRadius: 16,
          padding: 14,
        }}
      >
        <img
          src={p.heroImage}
          alt={`${p.name}`}
          className="product-card-image"
          style={{
            width: "100%",
            height: 240,
            objectFit: "contain",
            borderRadius: 12,
            filter: "drop-shadow(0 3px 6px rgba(0,0,0,0.07))",
          }}
        />
      </div>

      {/* Details */}
      <div className="product-card-details" style={{ flex: "1 1 60%" }}>
        <h3 style={{ margin: "0 0 6px 0", fontSize: "1.3rem", color: "#111" }}>
          {p.name}
        </h3>

        <p style={{ margin: "0 0 10px 0", color: "#444", lineHeight: 1.45 }}>
          {p.shortDescription}
        </p>

        <div style={{ marginBottom: 10 }}>
          {p.badges?.map((b) => (
            <Badge key={b}>{b}</Badge>
          ))}
        </div>

<span style={{ fontWeight: 600, fontSize: "1.05rem" }}>
          {getPriceDisplay(p.id)}
        </span>
        {/* Buttons */}
        <div
          className="product-card-buttons"
          style={{
            marginTop: 14,
            display: "flex",
            gap: 10,
            flexWrap: "wrap",
          }}
        >
          <Link
            to={`/product/${p.id}`}
            className="product-card-link"
            style={{
              textDecoration: "none",
              padding: "10px 14px",
              borderRadius: 12,
              border: "1px solid rgba(0,0,0,0.12)",
            }}
          >
            View details
          </Link>

          {/* אם תרצה להחזיר Add to cart מהרשימה — פשוט תוריד comment */}
          {/*
          <button
            onClick={handleAddToCart}
            className="product-card-add"
            style={{
              padding: "10px 14px",
              borderRadius: 12,
              border: "1px solid #000",
              background: "#000",
              color: "#fff",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            Add to cart
          </button>
          */}
        </div>
      </div>
    </div>
  );
}

// Main Products page
export default function Products() {
  return (
    <main
      role="main"
      aria-label="Lutology Products"
      style={{ padding: "40px 20px", maxWidth: 1100, margin: "0 auto" }}
    >
      <SEO
        title="Lutology Formulations"
        description="Explore Lutology's topical formulations built around high-purity molecules such as Luteolin. Designed for skin and hair vitality."
      />

      <header style={{ marginBottom: 24 }}>
        <h1 style={{ marginBottom: 8 }}>Our formulations</h1>
        <p style={{ margin: 0, color: "#444", maxWidth: 760 }}>
          We focus on topical systems built around a few key molecules —
          starting with Luteolin.
        </p>
      </header>

      <div
        className="products-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
          gap: 18,
        }}
      >
        {products.map((p) => (
          <ProductCard key={p.id} p={p} />
        ))}
      </div>
    </main>
  );
}
